export const dialogPaperProps = {
  width: "100%",
  maxWidth: "556px",
  mx: "5px",
  borderRadius: 4,
  boxShadow: "0px 4px 30px rgba(0, 0, 0, 0.08)",
};

export const missingModalField = {
  borderColor: "#2F2B3D38",
  color: "#2F2B3D",

  "& .MuiOutlinedInput-root": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "6px",
    padding: "0px",
    "& .MuiOutlinedInput-input": {
      padding: "6px",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
      },
      "&[type=number]": {
        MozAppearance: "textfield",
      },
    },
    "&:hover fieldset": {
      borderColor: "#46a091",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#46a091",
    },
  },
  width: "100%",
  maxWidth: "528px",
  "& .MuiInputBase-input.MuiOutlinedInput-input": {
    py: "8px",
    px: "12px",
  },
};

export const modalActions = {
  p: { xs: "16px", sm: "24px" },
  justifyContent: "space-between",
};

// Catalog check result (match / similar / create cards)
export const catalogCardStyle = {
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  alignItems: { xs: "stretch", sm: "center" },
  justifyContent: "space-between",
  gap: "12px",
  p: "12px 16px",
  border: "1px solid #EAEAEA",
  borderRadius: "10px",
  backgroundColor: "#FAFAFA",
};

export const catalogTitleStyle = {
  fontSize: "15px",
  fontWeight: 600,
  color: "#2F2B3DE5",
  overflowWrap: "anywhere",
};

export const catalogPathStyle = {
  fontSize: "13px",
  color: "#2F2B3DB2",
  overflowWrap: "anywhere",
};

export const primaryButtonStyle = {
  backgroundColor: "#248B70",
  color: "#fff",
  borderRadius: "10px",
  fontSize: "15px",
  px: 3,
  textTransform: "none",
  boxShadow: "none",
  whiteSpace: "nowrap",
  flexShrink: 0,
  "&:hover": { backgroundColor: "#1f7b63", boxShadow: "none" },
  "&:disabled": { backgroundColor: "#e0e0e0" },
};

export const secondaryButtonStyle = {
  color: "#248B70",
  borderColor: "#248B70",
  borderRadius: "10px",
  fontSize: "15px",
  px: 3,
  textTransform: "none",
  whiteSpace: "nowrap",
  flexShrink: 0,
  "&:hover": { borderColor: "#1f7b63", backgroundColor: "#E8F5F1" },
};

export const greyButtonStyle = {
  backgroundColor: "#6C727F",
  color: "#fff",
  fontSize: "15px",
  borderRadius: "10px",
  px: 3,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": { backgroundColor: "#5b5f6b", boxShadow: "none" },
};
